var _style, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSemFidelidadeAgger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFD618;}\r\n\t.st1{fill:#003E61;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.4,70.9c-0.2,0-0.3,0-0.5-0.1c-0.6-0.2-1.1-0.7-1.2-1.4l-3.1-21.8c-0.1-0.9,0.5-1.8,1.4-2 c0.9-0.2,1.8,0.5,1.9,1.5l2.6,17.9l11.6-14.1c0.6-0.7,1.7-0.8,2.4-0.2c0.7,0.6,0.8,1.7,0.2,2.4l-14,17.1 C26.4,70.6,25.9,70.9,25.4,70.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.7,104c-0.8,0-1.6-0.6-1.7-1.5l-2.7-17.9l-11.4,14.2c-0.6,0.7-1.7,0.9-2.4,0.3c-0.7-0.6-0.8-1.7-0.2-2.4 l13.9-17.3c0.4-0.5,1.1-0.8,1.8-0.6c0.7,0.2,1.1,0.7,1.2,1.4l3.3,21.8c0.1,0.9-0.5,1.8-1.4,2C127.9,103.9,127.8,104,127.7,104"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.8,126.9c-25.3,0-47.1-19.1-50.8-44.4c-0.1-0.9,0.5-1.8,1.4-2c0.9-0.2,1.8,0.5,1.9,1.5 c3.4,23.6,23.8,41.4,47.4,41.4c23.4,0,43.8-17.6,47.3-41c0.1-0.9,1-1.6,1.9-1.4c0.9,0.1,1.6,1,1.4,2 C121.7,108,99.9,126.9,74.8,126.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.2,71.3c-0.9,0-1.6-0.7-1.7-1.5c-2.6-24.6-23.1-43.2-47.6-43.2c-23.6,0-44,17.8-47.4,41.4 c-0.1,0.9-1,1.6-1.9,1.5c-0.9-0.1-1.6-1-1.4-2c3.7-25.3,25.5-44.3,50.8-44.3c26.3,0,48.2,19.9,51,46.3c0.1,0.9-0.6,1.8-1.5,1.9 C124.3,71.3,124.2,71.3,124.2,71.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123,121.9c0.6,0.6,0.6,1.7,0,2.3c-0.3,0.3-0.7,0.5-1.2,0.5c-0.4,0-0.8-0.2-1.2-0.5L74.4,77.9l-46.3,46.4 c-0.3,0.3-0.7,0.5-1.2,0.5s-0.8-0.2-1.2-0.5c-0.6-0.6-0.6-1.7,0-2.3l46.3-46.4L25.8,29.2c-0.6-0.6-0.6-1.7,0-2.3 c0.6-0.6,1.7-0.6,2.3,0l46.3,46.4l46.3-46.4c0.6-0.6,1.7-0.6,2.3,0c0.6,0.6,0.6,1.7,0,2.3L76.7,75.5L123,121.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemFidelidadeAgger);
export default __webpack_public_path__ + "static/media/sem-fidelidade-agger.b9f249fe88c9c380253fe787c15bd74f.svg";
export { ForwardRef as ReactComponent };